import { UserListQuery } from 'api/user/api.types';
import { getListUsersByFilters } from 'api/user/user.api';
import { create } from 'zustand';

export interface Permission {
    uuid: string
    name: string
    description: any
    profile: Profile
}

export interface Profile {
    uuid: string
    name: string
    description: any
    group: Group
}

export interface Group {
    uuid: string
    name: string
    description: any
}

export interface ContactList {
    uuid: string
    type: string
    value: string
}

export interface Address {
    municipality: string
}

export interface Validity {
    uuid: string
    dataFinal: string
    dataInicial: string
    fileUuid: string
    isActive: boolean
    file: File
}

export interface Institution {
    uuid: string
    caf: string
    identification: string
    name: string
}

export interface IUser {
    uuid: string
    name: string
    identification: string
    email: string
    position: string
    occupation: string
    isRegisterActive: boolean
    isRegisterBlocked: boolean
    permission: Permission
    contactList: ContactList[]
    address: Address
    validity?: Validity
    institution: Institution
}

export interface Info {
    count: number
    page: number
    take: number
}

export interface IUsersStore {
    users: IUser[];
    infoUsers: Info;
    setUsers: (users: IUser[]) => void;
    getUsers: (filters?: UserListQuery) => Promise<void>;
}

const useUsersStore = create<IUsersStore>((set) => ({
    users: [],
    infoUsers: {
        count: 0,
        page: 0,
        take: 0,
    },
    setUsers: (users: IUser[]) => set({ users }),
    getUsers: async (filters?: UserListQuery) => {
        const response = await getListUsersByFilters(filters as UserListQuery);
        set({ users: response.data as unknown as IUser[] });
        set({ infoUsers: response.info as unknown as Info });
    }
}));

export default useUsersStore;